import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { widthIsMatch } from '../../GeneralComponents/HelperFunctions/mediaQueryCheck';
import '../FormComponent/form.css';
import { UserContext } from '../context/userContext';
import { slideRightSidebar, slideLeftSidebar } from '../../GeneralComponents/HelperFunctions/sidebar';

class Navbar extends Component {
  constructor(props) {
      super(props);
      this.state = {  }
  }

  static contextType = UserContext

  componentDidMount() {
    const navbar = document.querySelector('.top--navbar');
    window.addEventListener('scroll', () => {
      (window.scrollY > 0) ? (
        navbar.classList.add('sticky_nav')
      ) : navbar.classList.remove('sticky_nav')
    })
  }

  componentWillUnmount() {
    const navbar = document.querySelector('.top--navbar');
    window.removeEventListener('scroll', () => {
      (window.scrollY > 0) ? (
        navbar.classList.add('sticky_nav')
      ) : navbar.classList.remove('sticky_nav')
    })
  }

  renderNavLink = (accountType, path) => {
    if (accountType === 'admin') {
       return (path === '/admin') ? (
          <Link to={{pathname: '/user/dashboard'}}>
            <li className="cursor-pointer margin-right-md">
              <i className="fas fa-newspaper font-lg"></i>
            </li>
          </Link>
        ) : (
          <Link to={{pathname: '/admin/dashboard'}}>
            <li className="cursor-pointer margin-right-md">
              <i className="fas fa-user-shield font-lg"></i>
            </li>
          </Link>
        )
    }else return null
  }

  checkPath = (path) => {
    console.log(path);
    switch(path) {
      case '/admin' :
        return false
      case '/user/profile' :
        return false
      case '/user/:username' :
        return false
      default:
        return true
    }
  }

  render() {
    console.log(this.props)
    const { data: { accountType, photoDetails } } = this.context
    const { path } = this.props.match;
    return (
      <header>
        <Link to="/" className="cursor-pointer">
          <div className="bckgr-white padding-left-sm color2 favicon">
            <div className="d-inline-block">
              <span className="paint-text italic font-sm">T</span>
              <span className="font-xsm">eam</span>
              <span className="paint-text italic font-sm">W</span>
              <span className="font-xsm">ork</span>
            </div>
          </div>
        </Link>
        <nav className="top--navbar d-flex nowrap align-items--center justify-content--s-between position-relative">
          {(this.checkPath(path)) ? (
            <i className="fas fa-bars color2 mobile font-md" onClick={(event) => slideLeftSidebar(event)}></i>
          ) : null }
          {path === '/admin' ? null : (
            <div className="search-box d-flex align-items--center nowrap">
              <input type="search" placeholder="Search by category"
                className="font-sm text-align-center font-weight-bold search" />
              <div className="search-btn d-flex nowrap align-items--center justify-content--center cursor-pointer">
                <i className="fas fa-search font-md"></i>
              </div>
            </div>
          )}
          <ul className="d-flex nowrap align-items--center">
            { this.renderNavLink(accountType, path) }
            <li className="cursor-pointer margin-right-md">
              <Link to="/user/profile">
                <div className="avatar--sm">
                  <img className="" 
                  src={photoDetails[0]}
                  alt="your avatar" />
                </div>
              </Link>
            </li>
            {path !== '/admin' ? (
              <i className="fas fa-users color2 mobile font-md" onClick={(event) => slideRightSidebar(event)}></i>
            ): null}
          </ul>
        </nav>
      </header>
    );
  }
}

export default Navbar;